module.exports = __webpack_public_path__ + "img/vagrant-color.bda6621e.svg";